import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ResetSection() {
  const tableData = [{
    sit: 'No sé qué cocinar sin inflarme',
    sin: 'Improvisás y pagás las consecuencias',
    con: '14 platos seguros listos del batch del domingo'
  }, {
    sit: 'Llego cansada a la noche',
    sin: 'Terminás comiendo cualquier cosa',
    con: 'Heladera blindada: calentás en 5 minutos'
  }, {
    sit: 'Pierdo tiempo cocinando cada día',
    sin: '45-60 min desde cero',
    con: '60 minutos el domingo resuelven toda la semana'
  }, {
    sit: 'La comida digestiva me parece sin sabor',
    sin: 'Pollo hervido sin nada',
    con: 'Aderezos y especias que dan sabor sin fermentar'
  }];
  return <section className="py-24 bg-brand-black border-t border-brand-gold/20" data-id="element-242">
      <div className="container mx-auto px-4" data-id="element-243">
        <div className="max-w-5xl mx-auto" data-id="element-244">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-245">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-gold mb-4 font-[Poppins,_sans-serif]" data-id="element-246">
              🗓️ ¿QUÉ AGREGA EL MÉTODO PLATO LIVIANO™?
            </h2>
          </motion.div>

          {/* Desktop table */}
          <div className="hidden md:block overflow-x-auto mb-16 rounded-xl border border-gray-800" data-id="element-247">
            <table className="w-full text-left border-collapse" data-id="element-248">
              <thead data-id="element-249">
                <tr className="bg-brand-dark" data-id="element-250">
                  <th className="p-4 border-b border-gray-800 font-bold text-white w-1/3" data-id="element-251">
                    Problema real
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-red-400 w-1/3" data-id="element-252">
                    <div className="flex items-center gap-2" data-id="element-253">
                      <X className="w-4 h-4" data-id="element-254" /> Sin Método
                    </div>
                  </th>
                  <th className="p-4 border-b border-gray-800 font-bold text-brand-light w-1/3" data-id="element-255">
                    <div className="flex items-center gap-2" data-id="element-256">
                      <Check className="w-4 h-4" data-id="element-257" /> Con Método
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-800" data-id="element-258">
                {tableData.map((row, i) => <tr key={i} className="hover:bg-brand-dark/50 transition-colors" data-id="element-259">
                    <td className="p-4 text-gray-300" data-id="element-260">{row.sit}</td>
                    <td className="p-4 text-gray-500" data-id="element-261">{row.sin}</td>
                    <td className="p-4 text-brand-light font-medium" data-id="element-262">
                      {row.con}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>

          {/* Mobile stacked cards */}
          <div className="md:hidden mb-16 rounded-2xl border border-gray-800 overflow-hidden" data-id="element-263">
            {/* Header */}
            <div className="bg-brand-dark p-5 flex flex-col items-center gap-3" data-id="element-264">
              <div className="flex items-center gap-2 text-red-400 font-bold text-base" data-id="element-265">
                ❌ Sin Método
              </div>
              <div className="flex items-center gap-2 text-brand-light font-bold text-base" data-id="element-266">
                ✅ Con Método
              </div>
            </div>

            {/* Rows */}
            {tableData.map((row, i) => <div key={i} className="border-t border-gray-800" data-id="element-267">
                {/* Situación */}
                <div className="px-5 py-4 bg-brand-black" data-id="element-268">
                  <p className="text-xs font-bold text-gray-400 mb-1" data-id="element-269">
                    Problema real:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-270">{row.sit}</p>
                </div>
                {/* Sin Reset */}
                <div className="px-5 py-4 bg-brand-dark/80" data-id="element-271">
                  <p className="text-xs font-bold text-red-400 mb-1 flex items-center gap-1.5" data-id="element-272">
                    ❌ Sin Método:
                  </p>
                  <p className="text-sm text-gray-400" data-id="element-273">{row.sin}</p>
                </div>
                {/* Con Reset */}
                <div className="px-5 py-4 bg-brand-green/5" data-id="element-274">
                  <p className="text-xs font-bold text-brand-light mb-1 flex items-center gap-1.5" data-id="element-275">
                    ✅ Con Método:
                  </p>
                  <p className="text-sm text-gray-200" data-id="element-276">{row.con}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}